import { render, staticRenderFns } from "./EntityNav.vue?vue&type=template&id=0e751380"
import script from "./EntityNav.vue?vue&type=script&lang=js"
export * from "./EntityNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e751380')) {
      api.createRecord('0e751380', component.options)
    } else {
      api.reload('0e751380', component.options)
    }
    module.hot.accept("./EntityNav.vue?vue&type=template&id=0e751380", function () {
      api.rerender('0e751380', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EntityNav.vue"
export default component.exports